import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const HotelBookingRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--hotel-booking']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
